import RowItemAddReceptionPeriodical from './RowItemAddReceptionPeriodical.jsx';
import RowItemListBriefJob from './RowItemListBriefJob.jsx';
export {
  RowItemAddReceptionPeriodical,
  RowItemListBriefJob
};



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/datatable/add/index.js